"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _link = require("@insided/deprecated-preact-components/menu/link");

var _dropdownUtils = require("../utils/dropdownUtils");

var _SimpleDropdown = _interopRequireDefault(require("./SimpleDropdown"));

var gaEvents = function gaEvents(url) {
  return {
    eventCategory: 'Homepage',
    eventAction: 'Menu clicked',
    eventLabel: {
      Link: url
    }
  };
};

var trackCategory = function trackCategory(title, url, isParent) {
  return {
    type: "Mega Menu click on ".concat(isParent ? 'parent ' : '', "category"),
    category_title: title,
    category_url: url,
    click_source: 'menu',
    category_type: "".concat(isParent ? 'parent ' : '', "category"),
    event_source: 'control'
  };
};

var getDropdownClassName = function getDropdownClassName(isHamburgerList, level) {
  if (isHamburgerList) {
    return 'dropdown--forums-overview--nested-hamburger';
  }

  if (level === 2) {
    return 'dropdown--forums-overview--nested-3';
  }

  return 'dropdown--forums-overview--nested-deep';
};

var NestedDropdownList = function NestedDropdownList(_ref) {
  var category = _ref.category,
      isHamburgerList = _ref.isHamburgerList,
      topOffset = _ref.topOffset,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 2 : _ref$level;
  var childrenToRender = category.children;

  if (childrenToRender.length === 0) {
    return null;
  }

  return (0, _preact.h)("li", {
    className: (0, _classnames.default)('dropdown', 'dropdown--forums-overview', 'main-menu-list--overflow-scroll'),
    id: "custom-mega-menu-category-dropdown-".concat(category.id),
    style: topOffset ? {
      top: "".concat(topOffset, "px")
    } : undefined
  }, (0, _preact.h)("ul", {
    className: "main-menu-list"
  }, childrenToRender.map(function (child) {
    var showAsLink = (0, _dropdownUtils.shouldRenderAsLink)(child, isHamburgerList !== null && isHamburgerList !== void 0 ? isHamburgerList : false);
    var childLink = (0, _preact.h)(_link.CategoryLink, {
      key: child.id,
      track: trackCategory(child.title, child.url, !showAsLink),
      gaEvents: gaEvents(child.url),
      tag: showAsLink ? 'a' : 'span',
      href: (0, _absoluteUrlRuntime.resolveUrl)(showAsLink ? child.url : undefined),
      title: child.title,
      isNested: child.children.length > 0,
      isHamburger: isHamburgerList,
      target: child.external ? '_blank' : undefined,
      rel: child.external ? 'noreferrer' : undefined
    }, !showAsLink ? (0, _preact.h)("strong", null, child.title) : child.title); // Create nested dropdown only if item has children and should not render as link

    if (!showAsLink && child.children.length > 0) {
      return (0, _preact.h)("li", {
        key: child.id,
        className: "main-menu-list__item",
        role: "none"
      }, (0, _preact.h)(_SimpleDropdown.default, {
        popupName: "custom-dropdown-".concat(category.id, "-").concat(child.id),
        className: getDropdownClassName(isHamburgerList !== null && isHamburgerList !== void 0 ? isHamburgerList : false, level),
        openOnHover: !isHamburgerList,
        trigger: childLink
      }, (0, _preact.h)(NestedDropdownList, {
        category: child,
        isHamburgerList: isHamburgerList,
        topOffset: topOffset,
        level: level + 1
      })));
    }

    return (0, _preact.h)("li", {
      key: child.id,
      className: "main-menu-list__item",
      role: "none"
    }, (0, _preact.h)("div", {
      role: "menuitem",
      tabIndex: -1
    }, childLink));
  })));
};

var _default = NestedDropdownList;
exports.default = _default;